<template>
  <div class="p-introduce">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>“数字经济”+“智能制造”</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div class="box">
        <div class="left_content">
          <p class="left_title">企业简介</p>
          <div class="line"></div>
          <div class="left_text" v-html="this.buildingText1"></div>
        </div>
        <div
          class="right_img"
          :style="{
            backgroundImage: 'url(' + introdeceImg + ')',
          }"
        ></div>
      </div>
      <div class="text" v-html="this.buildingText2"></div>
      <div
        class="img_box1"
        v-for="(item, index) in list"
        :key="index"
        :style="index % 2 === 0 ? '' : 'flex-direction: row-reverse;'"
      >
        <div
          class="left_img"
          :style="{ backgroundImage: 'url(' + item.image + ')' }"
        ></div>
        <div class="right_content">
          <img class="left_top" src="@/assets/img/about/icon1.png" />
          <p class="right_content_text">
            {{ item.tips }}
          </p>
          <img class="right_bottom" src="@/assets/img/about/icon2.png" />
        </div>
      </div>
      <div class="text1" v-html="this.buildingText3"></div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {
      introdeceImg: "",
      buildingText1: "",
      buildingText2: "",
      buildingText3: "",
    };
  },
  methods: {
    async init() {
      this.params = this.$route.params;
      this.getAjax();
      this.introdeceImg = await this.getMenuConfig("企业简介大图", "image");
      this.buildingText1 = await this.getMenuConfig("企业简介文本一", "tips");
      this.buildingText2 = await this.getMenuConfig("企业简介文本二", "tips");
      this.buildingText3 = await this.getMenuConfig("企业简介文本三", "tips");
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 400px;
  background: url(~@/assets/img/about/title.png) no-repeat center;
  background-size: cover;
}
.title_text {
  position: absolute;
  top: 98px;
  left: 50%;
  margin-left: -323px;
  width: 646px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  line-height: 84px;
  text-align-last: justify;
  text-align: justify;
}
.g-box {
  transform: translateY(-120px);
}
.box {
  width: 1100px;
  height: 260px;
  background: #fff;
  box-shadow: 0px 8px 16px 0px rgba(0, 32, 114, 0.1);
  display: flex;
  justify-content: space-between;
  .left_content {
    position: relative;
  }
  .right_img {
    width: 380px;
    height: 260px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .left_title {
    position: absolute;
    top: 40px;
    left: 59px;
    width: 112px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    z-index: 999;
  }
  .line {
    position: absolute;
    top: 67px;
    left: 59px;
    width: 112px;
    height: 10px;
    background: #ff8012;
    opacity: 0.8;
    z-index: 1;
  }
  .left_text {
    position: absolute;
    top: 120px;
    left: 59px;
    width: 580px;
    height: 84px;
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
  }
}
.text {
  width: 1100px;
  height: 84px;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
  margin: 60px 0;
}
.img_box1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  .left_img {
    width: 420px;
    height: 280px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.right_content {
  position: relative;
  width: 640px;
  height: 280px;
}
.right_content_text {
  position: absolute;
  top: 60px;
  left: 40px;
  width: 560px;
  height: 140px;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
}
.right_bottom {
  position: absolute;
  right: 0;
  bottom: 0;
}
.left_top {
  position: absolute;
  z-index: 1;
}
.text1 {
  width: 1100px;
  height: 112px;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
}
</style>
